import styled from '@emotion/styled'
import theme from '../../../../../styles/theme'

export const PlotAndNumbersContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-start;
  box-sizing: border-box;
  min-height: 7rem;
  position: relative;
  width: 100%;
  border: 2px solid ${(props) => theme.colors.backgroundMediumDark};
  border-radius: 1rem;
`
